<template>
	<v-dialog
		v-model="form_dialog"
		persistent
		max-width="800"
		scrollable
		@keydown.esc="close"
	>
		<v-card :loading="loading">
			<v-card-title v-if="id">이벤트광고 수정</v-card-title>
			<v-card-title v-else>이벤트광고 등록</v-card-title>
			<v-divider />

			<v-card-text class="pa-5 pb-0">
				<v-form
					ref="form"
					:novalidate="false"
					dense
					@submit.prevent="save"
					id="event-ad-submit"
				>
					<v-text-field
						label="광고번호"
						v-model="event_ad.id"
						disabled
					/>
					<v-text-field
						label="등록일시/관리자"
						v-model="event_ad.created_at"
						disabled
					/>

					<v-radio-group
						v-model="event_ad.division"
						label="구분"
						mandatory
						row
						class="pa-0 ma-0"
						:disabled="isAutoSaved()"
					>
						<v-radio
							v-for="(v, k) in division"
							v-bind:key="k"
							:value="k"
							:label="k"
							:color="v.color"
						/>
					</v-radio-group>

					<v-radio-group
						v-model="event_ad.division_type"
						label="분류"
						:disabled="isAutoSaved()"
						mandatory
						row
						class="pa-0 ma-0"
					>
						<v-radio
							v-for="type in division[event_ad.division].types"
							v-bind:key="type"
							:value="type"
							:label="type"
							:color="division[event_ad.division].color"
						/>
					</v-radio-group>

					<v-autocomplete
						label="제품"
						dense
						no-filter
						class="mb-0"
						color="blue-grey lighten-2"
						:items="searched_product_list"
						:search-input.sync="search"
						:loading="isLoading"
						:disabled="isAutoSaved()"
						:rules="[hasProduct]"
						@change="selectProduct"
					>
						<template v-slot:item="data">
							<v-list-item-content>
								<v-list-item-title>
									<v-chip
										x-small
										label
										outlined
										class="mr-1 pa-1"
										>{{ data.item.idProduct }}</v-chip
									>
									<v-chip
										x-small
										label
										outlined
										class="mr-1 pa-1"
										>{{ data.item.brandTitle }}</v-chip
									>
									{{ data.item.productTitle }}
									<v-chip
										v-if="!data.item.isDisplay"
										x-small
										label
										outlined
										color="red"
										class="mr-1 pa-1"
										>미전시</v-chip
									>
									<v-chip
										v-if="data.item.isDiscontinue"
										x-small
										label
										outlined
										color="red"
										class="mr-1 pa-1"
										>단종</v-chip
									>
								</v-list-item-title>
							</v-list-item-content>
						</template>
					</v-autocomplete>

					<v-chip-group column style="margin-top: -20px">
						<v-chip
							:close="!isAutoSaved()"
							v-for="product in selected_product_list"
							:key="product.idProduct"
							dense
							@click:close="removeProduct(product.idProduct)"
						>
							<v-chip x-small label outlined class="pa-1">{{
								product.idProduct
							}}</v-chip>
							<v-chip x-small label outlined class="pa-1">{{
								product.brandTitle || product.brand.name
							}}</v-chip>
							{{ product.productTitle }}
							<v-chip
								v-if="!product.isDisplay"
								x-small
								label
								outlined
								color="red"
								class="pa-1"
								>미전시</v-chip
							>
							<v-chip
								v-if="product.isDiscontinue"
								x-small
								label
								outlined
								color="red"
								class="pa-1"
								>단종</v-chip
							>
						</v-chip>
					</v-chip-group>

					<v-text-field
						label="제목*"
						v-model="event_ad.title"
						:disabled="isAutoSaved()"
						counter="100"
						maxlength="100"
						:rules="[rules.required]"
						hide-details="auto"
					/>
					<v-text-field
						label="광고문구*"
						v-model="event_ad.intro"
						counter="19"
						maxlength="19"
						:rules="[rules.required]"
						hide-details="auto"
					/>
					<v-text-field
						label="URL*"
						v-model="event_ad.url"
						v-if="event_ad.division == '외부'"
						:rules="[rules.required]"
						hide-details="auto"
					/>
					<v-text-field
						label="이벤트/캐스트 참조ID*"
						v-model="event_ad.division_id"
						v-else
						:disabled="isAutoSaved()"
						type="number"
						:rules="[rules.required]"
						hide-details="auto"
						ref="division_id"
					/>

					<v-input class="d-inline-flex text-center">
						<v-text-field
							type="datetime-local"
							label="노출시작*"
							v-model="event_ad.start_on"
							max="2038-01-18T23:59"
							min="1970-01-02T00:00"
							:disabled="isAutoSaved()"
							:rules="[rules.required]"
						/>
						~
						<v-text-field
							type="datetime-local"
							label="노출종료*"
							v-model="event_ad.end_on"
							max="2038-01-18T23:59"
							min="1970-01-02T00:00"
							:disabled="isAutoSaved()"
							:rules="[rules.required]"
						/>
					</v-input>
				</v-form>
			</v-card-text>

			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn @click="close">취소</v-btn>
				<v-btn form="event-ad-submit" type="submit" color="primary"
					>저장</v-btn
				>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import _ from 'lodash';
	import moment from 'moment';
	import v_rules from '@/lib/v-rules';

	const _data = {
		loading: false,
		search: null,
		selected_product_list: [],
		searched_product_list: [],
		isLoading: false,
		event: null,
		event_ad: {
			division: '외부',
			division_type: '특가',
			start_on: null,
			end_on: null,
		},
		event_ad_product_list: [],

		division: {
			외부: {
				color: 'purple',
				types: ['특가', '증정', '체험단', '샘플링'],
			},
			내부: {
				color: 'red',
				types: ['이벤트', '캐스트'],
			},
		},

		rules: {
			...v_rules,
		},
	};

	export default {
		props: {
			id: { type: Number, default: null },
			form_dialog: { type: Boolean, default: false },
		},

		data() {
			return _.cloneDeep(_data);
		},

		watch: {
			id(id) {
				if (id) {
					this.load(id);
				} else {
					this.init();
				}
			},
			search: _.debounce(async function (val) {
				if (!val || val.length == 1)
					return (this.searched_product_list = []);
				if (this.isLoading) return;

				this.isLoading = true;

				const params = { offset: 0, limit: 500 };
				if (/^\d+$/.test(val)) {
					params.idProduct = val;
				} else if (_.isString(val)) {
					params.searchWord = val;
				} else {
					return (this.isLoading = false);
				}

				const { data } = await this.$axiosAdmin2.get('/api/products', {
					params,
				});
				this.searched_product_list = _.filter(
					_.sortBy(data.data, [row => -row.idProduct]),
					row => {
						return !_.find(this.selected_product_list, {
							idProduct: row.idProduct,
						});
					}
				);
				this.isLoading = false;
			}, 500),
		},

		methods: {
			init() {
				this.$refs['form'].resetValidation();
				Object.assign(this.$data, _.cloneDeep(_data));
			},

			hasProduct(v) {
				return (
					this.selected_product_list.length > 0 ||
					'제품을 선택해주세요.'
				);
			},

			selectProduct(product) {
				this.search = null;
				if (!product) return;
				this.selected_product_list.push({ ...product, is_new: true });
				this.searched_product_list = [];
			},

			removeProduct(product_id) {
				this.selected_product_list = this.selected_product_list.filter(
					product => product.idProduct != product_id
				);
			},

			async load(id) {
				this.loading = true;
				const { data } = await this.$axiosAdmin2.get(
					`/api/event/ad/${id}`
				);
				this.event_ad = data.event_ad;
				this.event_ad.created_at = moment(
					this.event_ad.created_at
				).format('YYYY-MM-DD HH:mm');
				this.event_ad.start_on = moment(this.event_ad.start_on).format(
					'YYYY-MM-DDTHH:mm'
				);
				this.event_ad.end_on = moment(this.event_ad.end_on).format(
					'YYYY-MM-DDTHH:mm'
				);
				this.selected_product_list = data.event_ad_product_list;
				this.event = data.event;
				this.loading = false;
			},

			close($event, reload = false, page = 1) {
				this.init();
				this.$emit('close', $event, reload, page);
			},

			save($event) {
				if (!this.$refs['form'].validate()) return;

				this.loading = true;
				const body = {
					event_ad: _.omit(this.event_ad, 'created_at'),
					event_ad_product_list: this.selected_product_list.map(
						product => _.pick(product, 'idProduct')
					),
				};

				body.event_ad.start_on = moment(
					body.event_ad.start_on
				).toISOString();
				body.event_ad.end_on = moment(
					body.event_ad.end_on + ':59'
				).toISOString();

				this.$axiosAdmin2
					.post(`/api/event/ad/save`, body)
					.then(rs => {
						this.close($event, true, this.event_ad.id ? null : 1);
					})
					.catch(e => {
						if (e.response.status == 400) {
							this.event_ad.division_id = null;
							this.$refs.division_id.focus();
						}
						alert(e.response.data.message);
					})
					.finally(() => {
						this.loading = false;
					});
			},

			isAutoSaved() {
				return this.event && this.event.eventType != '글픽존';
			},
		},
	};
</script>

<style lang="scss" scoped></style>
